import { EnumUserRoles } from 'entities/Users/model/types'
import { type NavArea, type NavTarget } from 'entities/WebMcp/model/navAreas'

/**
 * Small curated "features you may have missed" list — the third pill tier, shown
 * only when onboarding is complete and the current page has no suggestions.
 * `area` is the owning area so the selector can drop items for the page the user
 * is already on. Role-filtered by `minRole`. Deliberately short (not derived).
 */
export interface DiscoveryItem {
  key: string
  label: string
  prompt: string
  minRole: EnumUserRoles
  area: NavArea
  targetDestination: NavTarget
}

export const DISCOVERY_ITEMS: readonly DiscoveryItem[] = [
  {
    key: 'find_conversation',
    label: 'Find a conversation',
    prompt: 'Find a conversation',
    minRole: EnumUserRoles.MEMBER,
    area: 'Inboxes',
    targetDestination: 'Inboxes',
  },
  {
    key: 'find_contact',
    label: 'Find a contact',
    prompt: 'Find a contact',
    minRole: EnumUserRoles.MEMBER,
    area: 'Contacts',
    targetDestination: 'Contacts',
  },
  {
    key: 'auto_reply',
    label: 'Set up an auto-reply',
    prompt: 'How do I set up an auto-reply for after hours?',
    minRole: EnumUserRoles.MEMBER,
    area: 'AI & Automation',
    targetDestination: 'AI & Automation',
  },
  {
    key: 'create_broadcast',
    label: 'Create a broadcast',
    prompt: 'Help me create a broadcast',
    minRole: EnumUserRoles.MEMBER,
    area: 'Outbound',
    targetDestination: 'Outbound',
  },
  {
    key: 'organize_tags',
    label: 'Organize contacts with tags',
    prompt: 'How do I use tags to organize my contacts?',
    minRole: EnumUserRoles.MEMBER,
    area: 'Contacts',
    targetDestination: 'Contacts',
  },
]
